import { Routes, Route, Outlet, Navigate } from 'react-router-dom';
import Auth from './modules/Auth';
import AuthRedirect from './modules/AuthRedirect';
import RecuperarSenha from './modules/RecuperarSenha';
import Advertiser from './modules/Adm/Advertiser';
import Offers from './modules/Adm/Offers';
import Category from './modules/Adm/Category';
import Team from './modules/Adm/Team';
import User from './modules/Adm/User';
import AdminProfile from './modules/Adm/User/Profile';
import Plans from './modules/Adm/Plans';
import Aditionals from './modules/Adm/Aditionals';
import Settings from './modules/Adm/Settings';
import AsaasWebhooks from './modules/Adm/AsaasWebhooks';
import AdmProtected from './modules/Adm/AdmProtected';
import Dashboard from './modules/Adm/Dashboard';
import ClubProtected from './modules/Club/ClubeProtected';
import AdvertiserDetails from './modules/Adm/Advertiser/AdvertiserDetails';
import ClubsDetails from './modules/Adm/Clubs/ClubsDetails';
import Clubs from './modules/Adm/Clubs';

import Club from './modules/Club';
import App from './modules/Adm/App';
import { Plan } from './modules/Order'; // Order deprecated — use PublicProposalPage
import PublicProposalPage from './modules/PublicProposal';
import Proposal from './modules/Adm/Proposal';
import ProposalPage from './modules/Adm/Proposal/ProposalPage';
import SalesOverview from './modules/Adm/SalesOverview';
import FinanceOverview from './modules/Adm/FinanceOverview';
import ClubsOverview from './modules/Adm/ClubsOverview';
import OfertasSocialSoul from './modules/Adm/SocialSoul/Ofertas';
import CuponsSocialSoul from './modules/Adm/SocialSoul/Coupons';
import ListSubscribers from './modules/Club/pages/ListSubscribers';

import ProductsClub from './modules/Club/ProductsClub';
import ListClubSales from './modules/Club/ListClubSales';
import SettingsClub from './modules/Club/pages/SettingsClub';
import ResaleClub from './modules/Club/pages/ResaleClub';
import ClubAccount from './modules/Club/pages/ClubAccount';
import ClubProfile from './modules/Club/pages/ClubProfile';
import ListClubMembers from './modules/Club/pages/ListClubMembers';
import NotificacoesClub from './modules/Club/pages/NotificacoesClub';
import ListWebhooks from './modules/Club/pages/ListWebhooks';
import Telemedicina from './modules/Adm/Providers/Telemedicina';
import Telepsicologia from './modules/Adm/Providers/Telepsicologia';
import Seguro from './modules/Adm/Providers/Seguro';
import OrdersSocialSoul from './modules/Adm/SocialSoul/Orders';
import CampaignsSocialSoul from './modules/Adm/SocialSoul/Campaigns';
import ProductsSocialSoul from './modules/Adm/SocialSoul/Products';
import ListApiTokens from './modules/Club/pages/ListApiTokens';
import ListAdvertisers from './modules/Club/pages/ListAdvertisers';
import ClubAdvertiserDetails from './modules/Club/pages/AdvertiserDetails';
import Rescues from './modules/Adm/Rescues';
import AdvertiserProtected from './modules/Advertiser/AdvertiserProtected';
import AdvertiserContractShell from './modules/Advertiser/AdvertiserContractShell';
import AdvertiserDashboard from './modules/Advertiser/pages/Dashboard';
import AdvertiserData from './modules/Advertiser/pages/AdvertiserData';
import AdvertiserUserProfile from './modules/Advertiser/pages/Profile';
import AdvertiserOffers from './modules/Advertiser/pages/Offers';
import AdvertiserUsers from './modules/Advertiser/pages/Users';
import AdvertiserRescues from './modules/Advertiser/pages/Rescues';
import AdvertiserValidateCode from './modules/Advertiser/pages/ValidateCode';
import AdvertiserOnboarding from './modules/Advertiser/pages/Onboarding';
import AdvertiserContract from './modules/Advertiser/pages/AdvertiserContract';
import RegisterAdvertiser from './modules/Advertiser/pages/RegisterAdvertiser';
import AdvertiserLoginPage from './modules/Advertiser/pages/AdvertiserLogin';
import AdvertiserInviteAccept from './modules/Advertiser/pages/AdvertiserInviteAccept';
import ClubLoginPage from './modules/Club/pages/ClubLogin';
import ClubInviteAccept from './modules/Club/pages/ClubInviteAccept';
import AdminInviteAccept from './modules/Adm/User/AdminInviteAccept';
import ClubTutorial from './modules/Club/pages/ClubTutorial';
import ClubHomeRedirect from './modules/Club/pages/ClubHomeRedirect';
import Telepet from './modules/Adm/Providers/Telepet';
import Cashback from './modules/Adm/Cashback';
import AdminSubscribers from './modules/Adm/Subscribers';
import AdminOrders from './modules/Adm/Orders';
import AdminSubscriptions from './modules/Adm/Subscriptions';
import AdminNotifications from './modules/Adm/Notifications';
import ListImports from './modules/Club/pages/ListImports';
import AwinQueue from './modules/Adm/Awin/AwinQueue';
import LomadeeQueue from './modules/Adm/Lomadee/LomadeeQueue';

export default function AppRoutes() {
    return (
        <Routes>
            <Route path="/" element={<Auth />} />
            <Route path="/auth" element={<AuthRedirect />} />
            <Route path="/recuperar-senha" element={<RecuperarSenha />} />
            {/* <Route path="/anunciante/cadastro" element={<AdvertiserRegister />} /> */}
            <Route path="/assinatura/:propostaId?" element={<PublicProposalPage />} />
            <Route path="/plano/:planId?" element={<Plan />} />
            <Route path="/anunciante/onboarding" element={<AdvertiserOnboarding />} />
            <Route path="/anunciante/registro-anunciante" element={<RegisterAdvertiser />} />
            <Route path="/anunciante/login" element={<AdvertiserLoginPage />} />
            <Route path="/anunciante/convite/:token" element={<AdvertiserInviteAccept />} />
            <Route path="/clube/login" element={<ClubLoginPage />} />
            <Route path="/clube/convite/:token" element={<ClubInviteAccept />} />
            <Route path="/convite/:token" element={<AdminInviteAccept />} />
            <Route path="dashboard" element={<AdmProtected />}>
                <Route index element={<Dashboard />} />
                <Route path="configuracoes" element={<Outlet />}>
                    <Route path="perfil" element={<AdminProfile />} />
                    <Route path="cargos" element={<Team />} />
                    <Route path="usuarios" element={<User />} />
                    <Route path="categorias" element={<Category />} />
                    <Route path="planos" element={<Plans />} />
                    <Route path="adicionais" element={<Aditionals />} />
                    <Route path="settings" element={<Settings />} />
                    <Route path="webhooks" element={<AsaasWebhooks />} />
                </Route>
                <Route path="anunciantes" element={<Outlet />}>
                    <Route index element={<Advertiser />} />
                    <Route path=":id" element={<AdvertiserDetails />} />
                </Route>
                <Route path="ofertas" element={<Offers />} />
                <Route path="resgates" element={<Rescues />} />
                <Route path="clubes" element={<Outlet />}>
                    <Route path="visao-geral" element={<ClubsOverview />} />
                    <Route index element={<Clubs />} />
                    <Route path=":id" element={<ClubsDetails />} />
                </Route>
                <Route path="assinantes" element={<AdminSubscribers />} />
                <Route path="financeiro" element={<FinanceOverview />} />
                <Route path="beneficios" element={<AdminOrders />} />
                <Route path="assinaturas" element={<AdminSubscriptions />} />
                <Route path="pedidos" element={<Navigate to="/dashboard/beneficios" replace />} />
                <Route path="cashback" element={<Cashback />} />
                <Route path="aplicativo" element={<App />} />
                <Route path="notificacoes" element={<AdminNotifications />} />
                <Route path="vendas" element={<SalesOverview />} />
                <Route path="propostas" element={<Outlet />}>
                    <Route index element={<Proposal />} />
                    <Route path=":id" element={<ProposalPage />} />
                </Route>

                <Route path="brokers" element={<Outlet />}>
                    <Route index path="socialsoul/cupons" element={<CuponsSocialSoul />} />
                    <Route path="socialsoul/ofertas" element={<OfertasSocialSoul />} />
                    <Route path="lomadee/campaigns" element={<CampaignsSocialSoul />} />
                    <Route path="lomadee/orders" element={<OrdersSocialSoul />} />
                    <Route path="lomadee/products" element={<ProductsSocialSoul />} />
                    <Route path="awin/fila" element={<AwinQueue />} />
                    <Route path="lomadee/fila" element={<LomadeeQueue />} />
                </Route>
                <Route path="providers" element={<Outlet />}>
                    <Route path="telemedicina" element={<Telemedicina />} />
                    <Route path="telepsicologia" element={<Telepsicologia />} />
                    <Route path="seguro" element={<Seguro />} />
                    <Route path="telepet" element={<Telepet />} />
                </Route>
            </Route>
            <Route path="clube" element={<ClubProtected />}>
                <Route path="tutorial" element={<ClubTutorial />} />
                <Route index element={<ClubHomeRedirect />} />
                <Route path="dashboard" element={<Club />} />
                <Route path="assinantes" element={<ListSubscribers />} />
                <Route path="assinantes/importacoes" element={<ListImports />} />
                {/* <Route path="resgates" element={<ListResets />} /> */}
                {/* <Route path="produtos" element={<ListProducts />} /> */}
                {/* <Route path="banners" element={<ListBanners />} />   */}
                <Route path="planos" element={<ProductsClub />} />
                <Route path="apitokens" element={<ListApiTokens />} />
                <Route path="usuarios" element={<ListClubMembers />} />

                <Route path="revenda" element={<ResaleClub />} />
                <Route path="vendas" element={<ListClubSales />} />
                {/* <Route path="assinatura" element={<ListClubSubscriptions />} />
                <Route path="assinatura/:id" element={<ListClubSubscriptions />} /> */}

                <Route path="personalizacao" element={<SettingsClub />} />
                <Route path="configuracoes" element={<Navigate to="/clube/personalizacao" replace />} />
                <Route path="configuracoes/banners" element={<Navigate to="/clube/personalizacao" replace />} />
                <Route path="configuracoes/menu" element={<Navigate to="/clube/personalizacao" replace />} />

                <Route path="conta" element={<ClubAccount />} />
                <Route path="perfil" element={<ClubProfile />} />
                <Route path="usuarios" element={<ListClubMembers />} />
                <Route path="notificacoes" element={<NotificacoesClub />} />
                <Route path="webhooks" element={<ListWebhooks />} />
                <Route path="anunciantes" element={<ListAdvertisers />} />
                <Route path="anunciantes/:id" element={<ClubAdvertiserDetails />} />
                {/* <Route index element={<ClubeSettings />} /> */}
                {/* <Route path="cargos" element={<Team />} />
                    <Route path="usuarios" element={<User />} />
                    <Route path="categorias" element={<Category />} />
                    <Route path="planos" element={<Plans />} />
                    <Route path="adicionais" element={<Aditionals />} /> */}
            </Route>

            <Route path="/anunciante/contrato" element={<AdvertiserContractShell />}>
                <Route index element={<AdvertiserContract />} />
            </Route>
            <Route path="anunciante" element={<AdvertiserProtected />}>
                <Route index element={<AdvertiserDashboard />} />
                <Route path="dados" element={<AdvertiserData />} />
                <Route path="perfil" element={<AdvertiserUserProfile />} />
                <Route path="ofertas" element={<AdvertiserOffers />} />
                <Route path="usuarios" element={<AdvertiserUsers />} />
                <Route path="resgates" element={<AdvertiserRescues />} />
                <Route path="validar" element={<AdvertiserValidateCode />} />
            </Route>
        </Routes>
    );
}
